/* Important Info component for the Rotate info */
import React from 'react';
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import styles from "../../styles/Callsheets.module.css";

const RotateInfo = () => {

  return (
    <div>
    <Row className="my-3">
      <Col md={{span: 10, offset: 1}}>
      <div className={`px-3 py-2 ${styles.SubTitle6 }`}>
        <p className={`${styles.Red} text-center`}>
          MULTIPLE DIRECTORS & ROTATING CREW </p>
        <hr className={`mt-2 mb-0`}/>
        <div>
        <p className={`pt-2`}>
        If the production has <span className={`${styles.Red}`}>multiple</span> Directors or rotating Callsheet Crew Positions:</p>
        <p className={`pt-2`}>
        <span className={`${styles.Red}`}>*</span> All Directors and Crew Members must be Registered and given
        the <span className={`${styles.Red}`}>Callname</span> from their Position.
        </p>
        <p className={`pt-2`}>
        <span className={`${styles.Red}`}>*</span> Whenever the Director or Crew Member changes
        the Position's details in Crew Info must be <span className={`${styles.Red}`}>updated</span> so 
        the current Director or Crew Member's details are always accurate
          for the Callsheet's automated Send functionality.</p>
        <p className={`pt-2`}>
        <span className={`${styles.Red}`}>*</span> The Callsheet's automated Send Button 
        will send the Callsheet to all current Callsheet Crew.
        </p>
        <p className={`pt-2`}>
        <span className={`${styles.Red}`}>*</span> The Callsheet's <span className={`${styles.Red}`}>Your Call</span> will 
        display the Calltime for the Position.
        </p>
        </div>
        <p className={`${styles.Small} pt-3`}>Note: To avoid confusion advise all Directors and rotating 
          Crew that the Your Call time is for the Position not the individual Crew Member or Director.
          </p>
        <p className={`${styles.Small} pt-2`}>
          Note: A record of all Directors or the Position's Crew Members may be kept
        in their Department's Extra Department Positions section.
          </p>
          <hr className={`mt-2 mb-0`}/>
        </div>
      </Col>
    </Row>
    </div>
  )
}

export default RotateInfo 